import { __asyncGenerator, __asyncValues, __await } from "tslib";
import { AsyncIterableX } from '../asynciterablex.mjs';
import { wrapWithAbort } from './withabort.mjs';
import { throwIfAborted } from '../../aborterror.mjs';
/** @ignore */
export class MapAsyncIterable extends AsyncIterableX {
    constructor(source, selector, thisArg) {
        super();
        this._source = source;
        this._selector = selector;
        this._thisArg = thisArg;
    }
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            var _b, e_1, _c, _d;
            throwIfAborted(signal);
            let i = 0;
            try {
                for (var _e = true, _f = __asyncValues(wrapWithAbort(this._source, signal)), _g; _g = yield __await(_f.next()), _b = _g.done, !_b; _e = true) {
                    _d = _g.value;
                    _e = false;
                    const item = _d;
                    const result = yield __await(this._selector.call(this._thisArg, item, i++, signal));
                    yield yield __await(result);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_e && !_b && (_c = _f.return)) yield __await(_c.call(_f));
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
}
/**
 * Projects each element of an async-enumerable sequence into a new form.
 *
 * @template TSource The type of the elements in the source sequence.
 * @template TResult The type of the elements in the result sequence, obtained by running the selector
 * function for each element in the source sequence.
 * @param {((value: TSource, index: number, signal?: AbortSignal) => Promise<TResult> | TResult)} selector A transform function
 * to apply to each source element.
 * @param {*} [thisArg] Optional this for binding to the selector.
 * @returns {OperatorAsyncFunction<TSource, TResult>} An async-iterable sequence whose elements are the result of invoking the transform
 * function on each element of source.
 */
export function map(selector, thisArg) {
    return function mapOperatorFunction(source) {
        return new MapAsyncIterable(source, selector, thisArg);
    };
}

//# sourceMappingURL=map.mjs.map
